<template>
  <router-view/>
</template>
<script>

import $vuex from '@/store'
import {getSiteSetInfo} from "@/api/setting";

export default {
  name: 'App',
  data() {
    return {
      active: 'home',
      wsMessage: null,//消息即时通讯
      msgList: [],//消息列表
      msg: false
    }
  },
  components: {},
  created() {
    this.loadSiteInfo()
  },
  methods: {
    loadSiteInfo() {
      try {
        // 站点配置信息
        getSiteSetInfo().then(({web_name, copyright, logo_url}) => {
          localStorage.setItem('app:web_name', web_name)
          localStorage.setItem('app:copyright', copyright)
          localStorage.setItem('app:logo_url', logo_url)
          $vuex.commit('handleSetSiteInfo', {
            web_name: web_name || '',
            copyright: copyright || '',
            logo_url: logo_url || ''
          })
        })

      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e)
      }

    }
  }

}
</script>

<style lang='scss'>

body {
  margin: 0;
  padding: 0;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-size: 14px;
  line-height: 1.15;
  color: #303133;
  background-color: #f0f2f5;
  overflow-x: hidden;
}

.el-button--medium {
  padding: 8px 10px;
}

.el-button--mini {
  padding: 7px 8px;
}

ul, li {
  padding: 0;
  margin: 0;
  list-style: none
}
</style>
